import { Provider } from "react-redux";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import ScrollToTop from "./ScrollToTop"; 
import Auth from "./layout/Auth";
import Main from "./layout/Main";
import routes from "./routes";
import store from "./store";
import ScrollLoadingBar from "./components/global/ScrollLoaddingBar";
import Aos from "aos";
import 'aos/dist/aos.css'; 
import { ToastContainer } from 'react-toastify';


function App() {
    if (typeof window !== "undefined") {
        Aos.init({
          duration: 1000,
          delay: 300
        });
    }
    return (
        <>
            <Provider store={store}>
                <BrowserRouter>
                    <ScrollToTop />
                    <Switch>
                        {routes.map((route, index) => (
                            <Route key={index} exact path={route.path}>
                                {route.layout === "main" ? (
                                    <Main>
                                        <route.component />
                                    </Main>
                                ) : (
                                    <Auth>
                                        <route.component />
                                    </Auth>
                                )}
                            </Route>
                        ))}
                        <Redirect to="/" />
                    </Switch>
                </BrowserRouter>
            </Provider>
            <ToastContainer theme="dark"/>
            <ScrollLoadingBar/>
                        
                        
        </>
    );
}

export default App;
